export default __webpack_public_path__ + "static/media/moles-removal.f6b96850.JPG";